export type RoomLayoutPickCandidate = {
  id: number;
  name?: string | null;
  setUpTime?: number | null;
  bookingLeadTime?: number | null;
};

/**
 * Mandatory room layout default: first orderable item whose name contains "standard" (case-insensitive),
 * else the item with lowest effective setup time (setUpTime ?? 15), first in array order on ties.
 */
export function pickMandatoryRoomLayoutDefault<T extends RoomLayoutPickCandidate>(
  layouts: T[]
): T | null {
  if (!layouts?.length) {
    return null;
  }

  // certain clients asks for 'standard'-named layout, so we need to find for the first one
  const firstStandard = layouts.find(layout =>
    (layout.name ?? "").toLowerCase().includes("standard")
  );
  if (firstStandard) return firstStandard;

  let best = layouts[0];
  let bestSetup = best.setUpTime ?? 15;
  for (let i = 1; i < layouts.length; i++) {
    const item = layouts[i];
    const setup = item.setUpTime ?? 15;
    if (setup < bestSetup) {
      best = item;
      bestSetup = setup;
    }
  }

  return best;
}
